const GUEST_PUBLIC_PATHS = [
	'/',
	'/discover',
	'/restart-password',
	'/restart-password-request',
	'/chat',
	'/studio',
	'/order-status',
];

export const isGuestPublicPath = (pathname = window.location.pathname) => {
	if (GUEST_PUBLIC_PATHS.includes(pathname)) {
		return true;
	}
	return pathname.startsWith('/discover')
		|| pathname.startsWith('/chat')
		|| pathname.startsWith('/restart-password/');
};
